import { Channel, ChannelPayloadFilter } from "spyne";
import { PricingTraits } from 'traits/pricing-traits';
import { AppDataTraits } from 'traits/app-data-traits';

export class ChannelAuth extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_AUTH";
    props.traits = [PricingTraits];
    props.sendCachedPayload = true;
    super(name, props);
  }

  onPreviewAuthRequest(e) {
    const { payload } = e;

    this.sendChannelPayload("CHANNEL_AUTH_WINDOW_REQUEST_EVENT", payload);

   //console.log("AUTH REQUEST FROM PREVIEW ", { payload, e });
  }

  onRegistered() {
    this.getChannel("CHANNEL_AUTH_CONFIG").subscribe(
      this.onAuthConfigLoaded.bind(this),
    );

    const authPayloadFilter = new ChannelPayloadFilter({
      type: "auth0",
    });

    const postMsgPayloadFilter = new ChannelPayloadFilter({
      payload: (pl) => pl?.metadata?.type === "authRequest",
    });

    this.getChannel("CHANNEL_POST_MSG", postMsgPayloadFilter).subscribe(
      this.onPreviewAuthRequest.bind(this),
    );

    const uiAuthPayloadFilter = new ChannelPayloadFilter({
      payload: (pl) => pl.eventType === "authEvent",
    });

    this.getChannel("CHANNEL_UI", uiAuthPayloadFilter).subscribe(
      this.onAuthUIEvent.bind(this),
    );

    // this.getChannel("CHANNEL_UI", authPayloadFilter).subscribe(
    //   this.auth$onUIEvent.bind(this),
    // );

    //window.setTimeout(this.loadTest.bind(this), 5000);
  }

  onAuthConfigLoaded(e) {
    const { domain, clientId } = e.payload;
    const authStateObj = AppDataTraits.api$GetAuthStateFromAuth0AndStripe();
    const action = "CHANNEL_AUTH_CONFIG_LOADED_EVENT";
    this.sendChannelPayload(action, { domain, clientId, authStateObj });
  }

  onAuthInitialized(e) {
    const { isAuthenticated,isAuthenticatedForBasicInfo, userProfile, userRecord } = e.payload;

    this.sendChannelPayload("CHANNEL_AUTH_AUTHENTICATION_EVENT", {
      isAuthenticated,
      isAuthenticatedForBasicInfo,
      userRecord,
      userProfile,
    });
  }

  onToggleUpdate(e) {
    const { toggleState } = e.payload;
    const action = "CHANNEL_AUTH_TOGGLE_PROFILE_EVENT";
    this.sendChannelPayload(action, { toggleState });
  }

  /*   onCallback(e) {
    this.auth$ResetCallback(e);
    this.sendPayloadToRouteChannel({ pageId: "home" });
  }*/
  onReset(e) {
    const action = "CHANNEL_AUTH_CALLBACK_RESET_EVENT";
    const onResetDelay = () => {
      const getPageIdFromLocalStorage = () => {
        let pageId = "home";
        const localStorageObj = JSON.parse(
          window.localStorage.getItem("spyneDocs1"),
        );

        return localStorageObj?.pageId !== undefined
          ? localStorageObj.pageId
          : pageId;
      };

      const pageId = getPageIdFromLocalStorage();
      //console.log("LOCAL STORAGE OBJ3 ", pageId);

      this.sendChannelPayload(action, { action });
      // const goHomeDelay = ()=>this.sendPayloadToRouteChannel({ pageId: 'configure', //eventPreventDefault:true });
      //window.setTimeout(goHomeDelay, 500);
    };

    requestAnimationFrame(onResetDelay);
  }

  onAuthUIEvent(e) {
    const {srcElement, payload} = e;
    const {el} = srcElement;
    const isPreviewEvent = el.classList.contains('btn-complete');
    const { type, isPricingEvent } = payload;

    const sendAuthEvent = ()=>{
      const action = isPreviewEvent ? "CHANNEL_AUTH_APP_LAUNCH_PREVIEW_WINDOW_EVENT" : "CHANNEL_AUTH_APP_CREATE_REQUEST_EVENT";



      this.sendChannelPayload(action, { action });

    }

    if (String(isPricingEvent) === "true"){
      this.pricing$onChannelSendUIEvent(e);
    } else {
      sendAuthEvent();
    }

    //console.log("EVENT TYPE IS ", { type, isPricingEvent, isPreviewEvent, el, payload, srcElement });



  }

  onAppCreateGenInitEvent(e) {
    const { payload, srcElement } = e;
    const action = "CHANNEL_AUTH_APP_CREATE_GENERATING_EVENT";
    this.sendChannelPayload(action, payload, srcElement);
  }

  onAppCreateCompleteSuccessEvent(e) {
    const { payload, srcElement } = e;
    const action = "CHANNEL_AUTH_APP_CREATE_COMPLETED_EVENT";
    this.sendChannelPayload(action, payload, srcElement);
  }

  addRegisteredActions() {
    return [
      "CHANNEL_AUTH_PRICING_EVENT",
      "CHANNEL_AUTH_MANAGE_SETTINGS_EVENT",
      "CHANNEL_AUTH_CALENDLY_EVENT",
      "CHANNEL_AUTH_CONFIG_LOADED_EVENT",
      "CHANNEL_AUTH_WINDOW_REQUEST_EVENT",
      "CHANNEL_AUTH_AUTHENTICATION_EVENT",
      "CHANNEL_AUTH_APP_CREATE_REQUEST_EVENT",
      [
        "CHANNEL_AUTH_APP_CREATE_GENERATING_INITIALIZED_EVENT",
        "onAppCreateGenInitEvent",
      ],
      "CHANNEL_AUTH_APP_CREATE_GENERATING_EVENT",
      [
        "CHANNEL_AUTH_APP_CREATE_COMPLETED_SUCCESS_EVENT",
        "onAppCreateCompleteSuccessEvent",
      ],
      "CHANNEL_AUTH_APP_CREATE_COMPLETED_EVENT",
      "CHANNEL_AUTH_APP_LAUNCH_PREVIEW_WINDOW_EVENT",
      ["CHANNEL_AUTH_TOGGLE_REQUEST_EVENT", "onToggleUpdate"],
      ["CHANNEL_AUTH_AUTHENTICATION_REQUEST_EVENT", "onAuthInitialized"],
      ["CHANNEL_AUTH_CALLBACK_RESET_REQUEST_EVENT", "onReset"],
      "CHANNEL_AUTH_CALLBACK_RESET_EVENT",
      "CHANNEL_AUTH_TOGGLE_PROFILE_EVENT",
      /*
      ["CHANNEL_AUTH_CALLBACK_EVENT", "onCallback"],
*/
    ];
  }

  onViewStreamInfo() {}
}
